import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "input-group-append" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionSelectorDialog = _resolveComponent("CriterionSelectorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionSelectorDialog, {
      viewModel: _ctx.criterionSelectorDialog,
      onConfirmSelection: _ctx.handleSetCriterion
    }, null, 8 /* PROPS */, ["viewModel", "onConfirmSelection"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.initialized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", null, [
                _createElementVNode("a", {
                  class: "text-dark",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Back ", -1 /* CACHED */)
                ]))])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Edit weighted score", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(_ctx.hasChanges ? 'btn btn-warning' : 'btn btn-outline-secondary'),
                disabled: _ctx.isSaving,
                style: {"padding":"0.7em 2em"},
                form: "edit-weighted-score-form"
              }, _toDisplayString(_ctx.saveButtonText), 11 /* TEXT, CLASS, PROPS */, _hoisted_5),
              (_ctx.hasChanges)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-secondary",
                    style: {"padding":"0.7em 2em"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
                  }, " Cancel "))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "mb-5" }, null, -1 /* CACHED */)),
          _createElementVNode("form", {
            id: "edit-weighted-score-form",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("label", null, [
                _createTextVNode("Name: "),
                _createElementVNode("span", { style: {"color":"red"} }, "*")
              ], -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                type: "text",
                class: "form-control",
                required: "",
                maxlength: "100",
                minlength: "2"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.nameError), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.description,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "Weights set:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.weightsSetId) = $event))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Default", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weightsSets, (ws) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: ws.CriteriaWeightsSetId
                  }, _toDisplayString(ws.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.weightsSetId]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Criterion:", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("input", {
                  value: _ctx.criterionLabel,
                  type: "text",
                  class: "form-control pointer bg-white",
                  readonly: "",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleShowCriterionSelector && _ctx.handleShowCriterionSelector(...args)))
                }, null, 8 /* PROPS */, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleShowCriterionSelector && _ctx.handleShowCriterionSelector(...args)))
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "fa-solid fa-ellipsis" }, null, -1 /* CACHED */)
                  ]))])
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}